import React from "react";
import Spinner from "./Spinner";
import { AlertSuccess, AlertError } from "./Alerts";
import { Empty } from "antd";

function ContentValidation({
  loader,
  array = [],
  alertId_s,
  alertId_e,
  children,
  error,
  identifier = 'bigbox'
}) {
  if(!!error) {
    return (
      <div>
        {JSON.stringify(error)}
      </div>
    )
  }
  return (
    <>
      {!loader ? (
        array.length > 0 ? (
          <>
            <AlertSuccess alertId={alertId_s} />
            <AlertError alertId={alertId_e} />
            {children}
          </>
        ) : (
          <>
            <AlertSuccess alertId={alertId_s} />
            <AlertError alertId={alertId_e} />
            <div className="d-flex justify-content-center">
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
            </div>
          </>
        )
      ) : (
        <Spinner identifier={identifier} />
      )}
    </>
  );
}

export default ContentValidation;
